import React, { forwardRef, useContext } from 'react';
import { LabelStyles } from './Label.styles.js';
import styled from 'styled-components';
import { FormContext } from '../Form/FormContext.js';
import { FormRowContext } from '../FormRow/FormRowContext.js';

const defaultProps = {
    sizing: 'medium',
};
const _Label = forwardRef(({ className, children, htmlFor: propHtmlFor, ...rest }, ref) => {
    var _a;
    const formRowContext = useContext(FormRowContext);
    const group = (_a = formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.group) !== null && _a !== void 0 ? _a : false;
    const Tag = group ? 'legend' : 'label';
    const htmlFor = group ? undefined : propHtmlFor !== null && propHtmlFor !== void 0 ? propHtmlFor : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.id;
    return (React.createElement(Tag, { className: className, htmlFor: htmlFor, ...rest, ref: ref }, children));
});
_Label.displayName = '_Label';
const Label = styled(_Label).attrs(({ sizing }) => {
    var _a, _b;
    const formContext = useContext(FormContext);
    const formRowContext = useContext(FormRowContext);
    return {
        sizing: (_b = (_a = sizing !== null && sizing !== void 0 ? sizing : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.sizing) !== null && _a !== void 0 ? _a : formContext === null || formContext === void 0 ? void 0 : formContext.sizing) !== null && _b !== void 0 ? _b : defaultProps.sizing,
    };
}) `
    ${LabelStyles}
`;

export { Label, defaultProps };
//# sourceMappingURL=Label.js.map
